// 用户管理
import http from "@/jslibs/axios/http";

// 用户列表
export const page = (data) => http.post("/web/userManager/getUserList", data);

// 用户详情
export const detail = (data) => http.post("/web/userManager/getUserDetail", data);

// 添加用户
export const add = (data) => http.post("/web/userManager/addUser", data);

// 编辑用户
export const edit = (data) => http.post("/web/userManager/editUser", data);

// 历史总数据
export const flyTotal = (data) => http.post("/web/userManager/getUserFlyTotal", data);

// 设备激活信息
export const deviceActivation = (data) => http.post("/web/userManager/getDeviceActivationRecordList", data);

// 设备使用数据
export const deviceUsage = (data) => http.post("/web/userManager/getDeviceTrajectoryRecordList", data);

// 用户反馈列表
export const feedbackPage = (data) => http.post("/web/userManager/getUserFeedbackList", data);

// 用户反馈详情
export const feedbackDetail = (data) => http.post("/web/userManager/getUserFeedbackDetail", data);
